import React, { useState, useEffect } from 'react';
import {
    List, Datagrid, TextField, SimpleForm, Toolbar as RaToolbar, SaveButton, Edit, EditButton, FunctionField,
    SimpleList, useRecordContext, useRedirect, usePermissions, useRefresh, Button as RaButton, useInput
} from 'react-admin';
import {
    useMediaQuery, makeStyles, withStyles, Typography, DialogContent, Dialog, FormControl, InputLabel, Select, MenuItem, Button, TextField as MuiTextField, IconButton, Checkbox, FormControlLabel, AccordionDetails, Accordion, AccordionSummary
} from '@material-ui/core';
import { customTheme } from "./customTheme";
import ScrollableTable from './components/ScrollableTable';
import Skeleton from '@material-ui/lab/Skeleton';
import { vehicleSvgs } from "./sharedData";
import config from './config.json';
import CustomSearch from './components/CustomSearch';
import ParkingSearchSelector from "./components/ParkingSearchSelector";
import * as CSV from 'csv-string';
import AssignmentTurnedInOutlinedIcon from '@material-ui/icons/AssignmentTurnedInOutlined';
import AddIcon from '@material-ui/icons/Add';
import { useLocation } from 'react-router-dom';
import CustomPagination from './components/CustomPagination';
import UseAnalyticsEvent from './utils/useAnalyticsEvent';
import { saveTokens } from './utils/saveTokens';
import notify from './components/CustomUseNotify';
import CustomDeleteButton from './CustomDeleteButton';
import queryString from 'query-string';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles({
    list: {
        marginBottom: 0,
    },
    parkingSelectorContainer: {
        display: "grid",
        justifyContent: "space-between",
    },
});

const CATEGORY = "PERMIT APARTMENT SECTION"

export const RfidApartmentList = props => {
    const eventTracker = UseAnalyticsEvent()
    const classes = useStyles();
    const location = useLocation();
    const { permissions } = usePermissions();
    const refresh = useRefresh()
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    const [addDialogVisible, setAddDialogVisible] = useState(false);
    const [parking, setParking] = useState(null);
    let prevSearch = sessionStorage.getItem(location.pathname) ? JSON.parse(sessionStorage.getItem(location.pathname)) : ""
    const [viewOnly] = useState(sessionStorage.getItem("view_only") === "1");
    //const [allowCompanyUserCreate] = useState(sessionStorage.getItem("allow_company_user_create") === "1");
    const [showFilter] = useState(sessionStorage.getItem("show_filter") === "1");
    const [apartmentAsUnit] = useState(sessionStorage.getItem("show_apartment_as_unit") === "1" ? "Unit" : "Flat No.")
    const [currentParking, setCurrentParking] = useState(prevSearch.currentParking ? prevSearch.currentParking : {});
    const zoneIds = currentParking.zone_ids ? currentParking.zone_ids.split(",") : null;
    const zoneLabels = currentParking.zones ? currentParking.zones.split(";") : null;
    const finalZones = zoneIds && zoneLabels ? zoneIds.map((id, index) => (
        { id, name: zoneLabels[index] }
    )) : null;
    if (finalZones)
        finalZones.sort((a, b) => (a.name > b.name ? 1 : (a.name < b.name ? -1 : 0)));

    let searchTypeState = ["Flat Number", "Tower Name", "Parking Slot"];
    const [search, setSearch] = useState(prevSearch.inputSearch);
    const [searchTypes, setSearchTypes] = useState(prevSearch.type ? prevSearch.type : "Flat Number");

    const filter = { search: { value: search ? search : "", type: searchTypes ? searchTypes : "" }, access_key: currentParking.id, parking_info_id: currentParking.allZones ? currentParking.parking_info_id : undefined };

    const onParkingChange = (parking) => {
        setCurrentParking({ ...parking, allZones: true });
    };

    const onZoneChange = (event) => {
        setCurrentParking({
            ...currentParking,
            id: event.target.value,
            name: zoneLabels[zoneIds.findIndex(id => id === event.target.value)],
            allZones: event.target.value === "All"
        });
    };

    const onCsvUpload = event => {
        if (event.target.files && event.target.files[0]) {
            const file = event.target.files[0];
            if (file.type === "application/vnd.ms-excel" && file.name.substr(-4) === ".csv") {
                var reader = new FileReader();
                reader.onload = function (e) {
                    const csvData = CSV.parse(reader.result);
                    if (csvData.length === 0) {
                        notify("No Data in the file", "warning");
                        return;
                    }
                    if (csvData[0].length !== 2) {
                        notify("Incorrect number of columns in the csv", "warning");
                        return;
                    }

                    const params = {
                        user_id: sessionStorage.getItem("user_id"),
                        apartments_data: csvData.slice(1),
                        access_key_id: parking.id
                    };
                    fetch(`${config.HOST_NAME}/crm/v3/rfidAddApartments`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                            'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                        },
                        body: JSON.stringify(params)
                    })
                        .then(response => {
                            saveTokens(response)
                            return response.json()
                        })
                        .then(json => {
                            if (json.success) {
                                notify('Apartments Added', "success");
                                refresh();
                                closeAddDialog();
                            } else {
                                notify(json.message, "warning");
                            }
                        })
                        .catch(error => {
                            notify('Error adding Apartment', 'warning');
                        });
                }
                reader.readAsText(file);
            } else {
                notify("Invalid File Format", "warning");
            }
        }
    };

    const closeAddDialog = () => {
        setAddDialogVisible(false);
    };

    React.useEffect(() => {
        eventTracker(CATEGORY, " APARTMENTS LIST")
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    React.useEffect(() => {
        const queryParams = queryString.parse(props.location.search);
        if (queryParams.parking)
            setCurrentParking(JSON.parse(queryParams.parking));
    }, [props]);

    return <div className={classes.list}>
        <div className={classes.parkingSelectorContainer} style={{ gridAutoFlow: isSmallDevice ? "row" : "column", gridTemplateColumns: isSmallDevice ? "100%" : "48% 48%", gridRowGap: isSmallDevice ? 18 : 0, margin: 0 }}>
            {showFilter &&
                <ParkingSearchSelector
                    value={currentParking}
                    onChange={onParkingChange}
                    clearable={true}
                    pathName={location.pathname}
                />
            }

            {currentParking.zone_ids && currentParking.zone_ids.includes(',') &&
                <FormControl variant="outlined" style={{ marginTop: isSmallDevice ? 0 : 10 }}>
                    <InputLabel>Zone Name</InputLabel>
                    <Select
                        value={currentParking.allZones ? "All" : currentParking.id}
                        onChange={onZoneChange}
                        label="Zone Name"
                        variant="outlined"
                    >
                        <MenuItem value="All">All</MenuItem>
                        {finalZones.map((zone, index) => (
                            <MenuItem key={index} value={zone.id}>{zone.name}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            }
        </div>
        <div className='customStyleForDataSearchDiv'>
            <CustomSearch search={search} setSearch={setSearch} searchTypes={searchTypes} setSearchTypes={setSearchTypes} searchTypeState={searchTypeState} pathName={location.pathname} />
            {!viewOnly && permissions === 'admin' &&
                <RaButton className='customCreateBtnStyle' title='Add' onClick={() => setAddDialogVisible(true)}>
                    <AddIcon />
                </RaButton>
            }
        </div>
        {/* <div style={{ display: "flex", justifyContent: "end" }}>
            <CustomFilter filterTypesInitState={filterTypesInitState} filterListValue={filterListValue} setFilterListValue={setFilterListValue} valueByFilterInitState={valueByFilterInitState} />

        </div> */}
        <List
            style={{ marginTop: 20 }}
            {...props}
            title="Apartments"
            bulkActionButtons={false}
            exporter={false}
            filter={filter}
            empty={false}
            hasCreate={!viewOnly}
            actions={false}
            pagination={<CustomPagination />}
        >
            {isSmallDevice ?
                <SimpleList
                    primaryText={record => null}
                    secondaryText={record => (<div>
                        <div style={{ color: customTheme.palette.secondary.main }}>{record["flat_number"] ? `${apartmentAsUnit}: ${record["flat_number"]}` : ""}</div>
                        <div style={{ color: customTheme.palette.secondary.main }}>{record["tower_name"] ? `Tower Name: ${record["tower_name"]}` : ""}</div>
                        <div style={{ color: customTheme.palette.secondary.main }}>{record["parking_name"] ? `Parking Name: ${record["parking_name"]}` : ""}</div>
                        <VehicleCapacityField vehicleTypes={["2", "4"]} isSmallDevice={isSmallDevice} />
                        {!viewOnly && <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
                            {/* {!viewOnly && allowCompanyUserCreate && <CustomCreateUserButton {...props} record={record} source="username" />} */}
                            <EditButton {...props} record={record} />
                            {permissions === 'admin' && <CustomDeleteButton {...props} record={record} refresh={refresh} resourcePath={'v3/rfidApartments'} />}
                        </div>}
                    </div>)}
                    onContextMenu={event => event.preventDefault()}
                    linkType={false}
                    rowStyle={() => ({ alignItems: "flex-start", borderBottom: "1px solid #18cc69" })}
                />
                :
                <Datagrid className={!viewOnly ? 'rfidApartmentsDataGrid' : ''} component={ScrollableTable}>
                    <TextField source="flat_number" label={apartmentAsUnit} />
                    <TextField source="tower_name" label="Tower Name" />
                    <TextField source="parking_name" label="Parking Name" />
                    <VehicleCapacityField label="Vehicle Occupancy" vehicleTypes={["2", "4"]} />
                    {/* {!viewOnly && allowCompanyUserCreate && <CustomCreateUserButton source="username" />} */}
                    {/* {!viewOnly && permissions === 'admin' && <EditButton />}
                    {!viewOnly && permissions === 'admin' && <DeleteButton mutationMode="pessimistic" />} */}
                    {!viewOnly && <FunctionField className="ListIconsContainerRfidApartments" render={record => record &&
                        <div className="ListIcons">

                            <div>
                                <EditButton {...props} title="Edit" label={false} record={record} />
                            </div>
                            {permissions === 'admin' && <div>
                                <CustomDeleteButton {...props} record={record} refresh={refresh} resourcePath={'v3/rfidApartments'} />
                            </div>}

                        </div>
                    } />}
                </Datagrid>
            }
        </List>

        <Dialog fullWidth open={addDialogVisible} onClose={closeAddDialog}>
            <div style={{ padding: "20px" }}>
                <Typography>Select Parking</Typography>
                <DialogContent style={{ display: "grid", gridRowGap: 20, marginTop: "10px" }}>
                    <ParkingSearchSelector
                        value={parking}
                        onChange={setParking}
                        clearable={false}
                        zones={true}
                        size="small"
                    />
                    <RaButton variant='outlined' label="Upload File" style={{ alignSelf: "flex-end", paddingLeft: 10, paddingRight: 15, position: "relative", height: "40px" }} disabled={parking === null}>
                        <>
                            <AssignmentTurnedInOutlinedIcon />
                            <input type="file" accept=".csv" onChange={onCsvUpload} style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", opacity: 0, cursor: "inherit" }} />
                        </>
                    </RaButton>
                </DialogContent>
            </div>
        </Dialog>
    </div>
};

const VehicleCapacityField = (props) => {
    const { vehicleTypes, isSmallDevice } = props;
    const record = useRecordContext(props);
    //const notify = useNotify();

    const [loading, setLoading] = useState(true);
    const [occupancyData, setOccupancyData] = useState({});

    useEffect(() => {
        fetch(`${config.HOST_NAME}/crm/v3/rfidApartments/${record.id}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            },
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then(json => {
                setLoading(false);
                if (json.success) setOccupancyData(json.data.occupancy);
            })
            .catch((error) => {
                setLoading(false);
                notify('Error fetching occupany data', 'warning');
            });
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return (vehicleTypes.map(vehicleType => (
        <div style={{ marginRight: 7, marginTop: isSmallDevice ? 5 : 0, padding: "4px 10px", border: "1px solid #aaa", borderRadius: 1000, display: "inline-flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
            <img className="summaryVehicleIcon" src={vehicleSvgs[vehicleType]} alt={`Vehicle Type ${vehicleType}`} />
            <div style={{ marginLeft: 7, fontSize: 14 }}>
                {loading ?
                    <Skeleton variant="text" height={18} width={20} style={{ display: "inline-block", transform: "none" }} />
                    :
                    occupancyData[vehicleType]
                }
                /{record[`vehicle_type_${vehicleType}_capacity`]}
            </div>
        </div>
    )));
};
// const validateUserCreation = (values) => {
//     const errors = {};
//     if (values.name == null || values.name === "") {
//         errors.name = 'Company Name is Required';
//     } else if (values.name.length > 200) {
//         errors.name = 'Company Name is too long';
//     }

//     if (values.vehicle_type_2_capacity == null || values.vehicle_type_2_capacity === "") {
//         errors.vehicle_type_2_capacity = 'Bike Capacity is Required';
//     } else if (typeof values.vehicle_type_2_capacity === "string" && values.vehicle_type_2_capacity.search(/^\d+$/g) === -1) {
//         errors.vehicle_type_2_capacity = 'Invalid Bike Capacity';
//     }

//     if (values.vehicle_type_4_capacity == null || values.vehicle_type_4_capacity === "") {
//         errors.vehicle_type_4_capacity = 'Car Capacity is Required';
//     } else if (typeof values.vehicle_type_4_capacity === "string" && values.vehicle_type_4_capacity.search(/^\d+$/g) === -1) {
//         errors.vehicle_type_4_capacity = 'Invalid Car Capacity';
//     }

//     if (values.access_key_id == null || values.access_key_id === "") {
//         errors.access_key_id = 'Please select a parking';
//     }

//     if (values.mobile_number != null && values.mobile_number !== "" && values.mobile_number.search(/^\d{10}$/g) === -1) {
//         errors.mobile_number = 'Invalid Mobile Number';
//     }

//     return errors;
// };
// export const RfidApartmentCreate = ({ permissions, ...props }) => {
//     const [allowCompanyUserCreate] = useState(sessionStorage.getItem("allow_company_user_create") === "1");

//     return (
//         <Create {...props} title="Create RFID Organization">
//             <SimpleForm validate={validateUserCreation} redirect="list">
//                 <div style={{ display: "flex", width: "100%", gap: 25 }}>
//                     <TextInput source="name" label="Company Name" variant="outlined" />
//                     {allowCompanyUserCreate && <RaCheckBoxInput source="create_user" label="Create User" style={{ position: "relative", top: -10 }} />}
//                 </div>
//                 <div style={{ display: "flex", width: "100%", gap: 25 }}>
//                     <TextInput source="vehicle_type_2_capacity" label="Total Bike Capacity" variant="outlined" />
//                     <TextInput source="vehicle_type_4_capacity" label="Total Car Capacity" variant="outlined" />
//                 </div>
//                 <div style={{ display: "flex", width: "100%", gap: 25 }}>
//                     <TextInput source="owner_name" label="Owner Name" variant="outlined" />
//                     <TextInput source="mobile_number" label="Mobile Number" variant="outlined" />
//                 </div>
//                 <RaAutocompleteInput source="access_key_id" resourceParam="name" resourcePath="uniqueParkingAccessKeys" label="Parking" getOptionValue={option => option["id"]} getOptionLabel={option => option["name"]} style={{ minWidth: 340, maxWidth: 500, marginTop: 10, marginBottom: 30 }} />
//             </SimpleForm>
//         </Create>
//     )
// };

const validateEdit = values => {
    const errors = {};
    if (values.vehicle_type_2_capacity == null || values.vehicle_type_2_capacity === "") {
        errors.vehicle_type_2_capacity = 'Bike Capacity is Required';
    } else if (typeof values.vehicle_type_2_capacity === "string" && values.vehicle_type_2_capacity.search(/^\d+$/g) === -1) {
        errors.vehicle_type_2_capacity = 'Invalid Bike Capacity';
    }

    if (values.vehicle_type_4_capacity == null || values.vehicle_type_4_capacity === "") {
        errors.vehicle_type_4_capacity = 'Car Capacity is Required';
    } else if (typeof values.vehicle_type_4_capacity === "string" && values.vehicle_type_4_capacity.search(/^\d+$/g) === -1) {
        errors.vehicle_type_4_capacity = 'Invalid Car Capacity';
    }
    return errors;
};

const toolbarStyles = {
    toolbar: {
        display: 'flex',
        justifyContent: 'space-between',
    },
};
const CustomToolbar = withStyles(toolbarStyles)(props => (
    <RaToolbar {...props}>
        <SaveButton />
    </RaToolbar>
));

export const RfidApartmentEdit = (props) => {
    const classes = useStyles();
    const redirect = useRedirect();
    const onSuccess = () => {
        notify("Element Updated", "success")
        redirect(props.basePath)
    }
    const onFailure = (error) => {
        notify(error.message, "warning")
    }

    return (
        <Edit {...props} onFailure={onFailure} onSuccess={onSuccess} undoable={false} classes={{ noActions: classes.editNoActions }}>
            <SimpleForm redirect="list" toolbar={<CustomToolbar />} style={{ padding: "0 12px" }} validate={validateEdit} >
                <div className="grid-250 apartment-edit-step-1" style={{ marginTop: 10, marginBottom: 30 }}>
                    <div>
                        <div style={{ position: 'relative', top: 3, fontSize: 12, color: '#BDBDBD', marginBottom: 5 }}>Parking Name</div>
                        <TextField source='parking_name' style={{ color: customTheme.palette.secondary.main, fontSize: 18 }} ></TextField>
                    </div>
                    <div>
                        <div style={{ position: 'relative', top: 3, fontSize: 12, color: '#BDBDBD', marginBottom: 5 }}>Flat</div>
                        <TextField source='flat_number' style={{ color: customTheme.palette.secondary.main, fontSize: 18 }}></TextField>
                    </div>
                    <div>
                        <div style={{ position: 'relative', top: 3, fontSize: 12, color: '#BDBDBD', marginBottom: 5 }}>Tower</div>
                        <TextField source='tower_name' style={{ color: customTheme.palette.secondary.main, fontSize: 18 }} ></TextField>
                    </div>
                </div>
                <CustomFormField />
            </SimpleForm>
        </Edit>
    );
}

function processSlotArea(slotArea) {
    try {
        const parsedArray = JSON.parse(slotArea);
        if (Array.isArray(parsedArray) && parsedArray.length > 0) {
            const resultArray = parsedArray;
            return resultArray;
        } else {
            return [];
        }
    } catch (error) {
        console.error('Error parsing slot_area:', error);
        return [];
    }
}

const CustomFormField = (props) => {
    const { record } = props
    console.log(record.slot_areas, "slot record")
    const { input: { onChange: set_vehicle_type_2_capacity } } = useInput({ ...props, id: "vehicle_type_2_capacity", source: "vehicle_type_2_capacity" });
    const { input: { onChange: set_vehicle_type_4_capacity } } = useInput({ ...props, id: "vehicle_type_4_capacity", source: "vehicle_type_4_capacity" });
    const { input: { value: enable_parking_slots, onChange: set_enable_parking_slots } } = useInput({ ...props, id: "enable_parking_slots", source: "enable_parking_slots" });
    const { input: { onChange: set_apartment_slots } } = useInput({ ...props, id: "apartment_slots", source: "apartment_slots" });

    const [bikecapacity, setBikecapacity] = useState(0)
    const [carCapacity, setCarcapacity] = useState(0)

    const [parkingSlots, setParkingSlots] = useState([])
    const [bikeSlots, setBikeSlots] = useState([])
    const [carSlots, setCarSlots] = useState([])

    const [slotAreas , setSlotAreas] = useState([])

    const addParkingSlots = (vehicle_type) => {
        if (vehicle_type === 2) {
            setBikeSlots(slots => {
                const copy = [...slots]
                copy.push({ id: '', slot_name: '', slot_type: vehicle_type })
                return copy
            })
            setBikecapacity(prev => {
                set_vehicle_type_2_capacity(+prev + 1)
                return +prev + 1
            })
        }
        if (vehicle_type === 4) {
            setCarSlots(slots => {
                const copy = [...slots]
                copy.push({ id: '', slot_name: '', slot_type: vehicle_type })
                return copy
            })
            setCarcapacity(prev => {
                set_vehicle_type_4_capacity(+prev + 1)
                return +prev + 1
            })
        }
    }

    const removeParkingSlots = (val, index) => {
        if (val.slot_type === 2 && +bikecapacity > 0) {
            setBikeSlots(slots => {
                const copy = [...slots]
                copy.splice(index, 1)
                return copy
            })
            setBikecapacity(prev => {
                set_vehicle_type_2_capacity(+prev - 1)
                return +prev - 1
            })
        }
        if (val.slot_type === 4 && +carCapacity > 0) {
            setCarSlots(slots => {
                const copy = [...slots]
                copy.splice(index, 1)
                return copy
            })
            setCarcapacity(prev => {
                set_vehicle_type_4_capacity(+prev - 1)
                return +prev - 1
            })
        }
    }

    const enableParkingSlotHandler = (e) => {
        set_enable_parking_slots(e.target.checked === true ? 1 : 0)
        if (e.target.checked) {
            if (!parkingSlots[0]) {
                const newBikeSlots = [...Array(bikecapacity)].map((s) => {
                    return { id: '', slot_name: '', slot_type: 2 }
                })
                const newCarSlots = [...Array(carCapacity)].map((s) => {
                    return { id: '', slot_name: '', slot_type: 4 }
                })
                setBikeSlots(newBikeSlots)
                setCarSlots(newCarSlots)
            }
            if (+bikecapacity > bikeSlots.length && parkingSlots[0]) {
                const newBikeSlots = [...Array(+bikecapacity - bikeSlots.length)].map((s) => {
                    return { id: '', slot_name: '', slot_type: 2 }
                })
                setBikeSlots([...bikeSlots, ...newBikeSlots])
            }
            if (+carCapacity > carSlots.length && parkingSlots[0]) {
                const newCarSlots = [...Array(+carCapacity - carSlots.length)].map((s) => {
                    return { id: '', slot_name: '', slot_type: 4 }
                })
                setCarSlots([...carSlots, ...newCarSlots])
            }
            if (+bikecapacity !== 0 && +bikecapacity < bikeSlots.length && parkingSlots[0]) {
                setBikeSlots([...bikeSlots.slice(0, +bikecapacity)])
            }
            if (+carCapacity !== 0 && +carCapacity < carSlots.length && parkingSlots[0]) {
                setCarSlots([...carSlots.slice(0, +carCapacity)])
            }
            if (+bikecapacity === 0) setBikeSlots([])
            if (+carCapacity === 0) setCarSlots([])

        }

    }

    const onChangeBikeHandler = (e, index) => {
        setBikeSlots(slots => {
            const copy = [...slots]
            copy[index] = { ...copy[index], slot_name: e.target.value }
            return copy
        })
    }

    const onChangeBikeSlotArea = (e, index) => {
        setBikeSlots(slots => {
            const copy = [...slots]
            copy[index] = { ...copy[index], slot_area_id: e.target.value }
            return copy
        })
    }

    const onChangeCarHandler = (e, index) => {
        setCarSlots(slots => {
            const copy = [...slots]
            copy[index] = { ...copy[index], slot_name: e.target.value }
            return copy
        })
    }

    const onChangeCarSlotArea = (e, index) => {
        setCarSlots(slots => {
            const copy = [...slots]
            copy[index] = { ...copy[index], slot_area_id: e.target.value }
            return copy
        })
    }

    useEffect(() => {
        if (record && record.parking_slots && JSON.parse(record.parking_slots)[0] && JSON.parse(record.parking_slots)[0].id !== null && JSON.parse(record.parking_slots)[0].id !== 'null') {
            let slots = JSON.parse(record.parking_slots)
            let bikeSlots = slots.filter((value) => value.slot_type === 2)
            let carSlots = slots.filter((value) => value.slot_type === 4)
            setParkingSlots(slots)
            setBikeSlots(bikeSlots)
            setCarSlots(carSlots)
            set_enable_parking_slots(1)
            if (+record.vehicle_type_2_capacity > bikeSlots.length) {
                const newBikeSlots = [...Array(+record.vehicle_type_2_capacity - bikeSlots.length)].map((s) => {
                    return { id: '', slot_name: '', slot_type: 2 }
                })
                setBikeSlots([...bikeSlots, ...newBikeSlots])
            }
            if (+record.vehicle_type_4_capacity > carSlots.length) {
                const newCarSlots = [...Array(+record.vehicle_type_4_capacity - carSlots.length)].map((s) => {
                    return { id: '', slot_name: '', slot_type: 4 }
                })
                setCarSlots([...carSlots, ...newCarSlots])
            }
        }
        if (record && record.vehicle_type_2_capacity) setBikecapacity(+record.vehicle_type_2_capacity)
        if (record && record.vehicle_type_4_capacity) setCarcapacity(+record.vehicle_type_4_capacity)
        if(record && record.slot_areas) setSlotAreas(processSlotArea(record.slot_areas))
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        set_apartment_slots([...bikeSlots, ...carSlots])
    }, [bikeSlots, carSlots]) // eslint-disable-line react-hooks/exhaustive-deps


    return <>
        <div className="grid-250 apartment-edit-step-2" style={{ marginBottom: 20, gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr)) !important' }}>
            <MuiTextField
                label="Bike capacity"
                size="small"
                value={bikecapacity} onChange={(e) => setBikecapacity(prev => {
                    set_vehicle_type_2_capacity(e.target.value)
                    return e.target.value
                })}
                variant='outlined'
                disabled={enable_parking_slots === 1}
            />
            <MuiTextField
                label="Car capacity"
                size="small"
                value={carCapacity} onChange={(e) => setCarcapacity(prev => {
                    set_vehicle_type_4_capacity(e.target.value)
                    return e.target.value
                })}
                variant='outlined'
                disabled={enable_parking_slots === 1}
            />
        </div>

        <Accordion className='apartment-edit-step-3' expanded={enable_parking_slots === 1 ? true : false}>
            <AccordionSummary style={{ cursor: "default" }}>
                <FormControlLabel
                    checked={enable_parking_slots === 1 ? true : false}
                    onChange={(event) => enableParkingSlotHandler(event)}
                    control={<Checkbox />}
                    label="Add Parking Slots"
                />
            </AccordionSummary>
            <AccordionDetails>
                <div>
                    <div style={{ display: "flex", justifyContent: "start", alignItems: "start", flexDirection: "column", marginBottom: "20px" }}>
                        <div style={{ display: "flex", justifyContent: "space-between", width: "100%", marginBottom: 10 }}>
                            <div>
                                <Typography style={{ color: "#212121" }}>Bike</Typography>
                            </div>
                            <Button variant='outlined' color='primary' size='small' onClick={() => addParkingSlots(2)} startIcon={<AddIcon />} >Add</Button>
                        </div>
                        {
                            bikeSlots && bikeSlots[0] && bikeSlots.map((val, index) => {
                                return (
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', marginBottom: 10, marginTop: 10, gap: 20 }}>

                                        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 250px))", gap: 20, width: "100%" }}>
                                            <MuiTextField
                                                label="Slot Name"
                                                size="small"
                                                value={val.slot_name}
                                                onChange={(e) => { onChangeBikeHandler(e, index) }}
                                                variant='outlined'
                                            />
                                        </div>
                                        {
                                            slotAreas[0] && 
                                            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 250px))", gap: 20, width: "100%" }}>
                                                <MuiTextField
                                            size="small"
                                            variant="outlined"
                                            label="Slot Area"
                                            select
                                            value={val.slot_area_id}
                                            onChange={(e) => { onChangeBikeSlotArea(e, index) }}
                                        >
                                            <MenuItem value=""></MenuItem>
                                            {slotAreas.map((area, index) => (
                                                <MenuItem key={index} value={area.id}>
                                                    {area.name}
                                                </MenuItem>
                                            ))}
                                        </MuiTextField>
                                            </div>
                                        }
                                            <div>
                                                <IconButton style={{ width: 25, height: 25 }} onClick={() => removeParkingSlots(val, index)}> <CloseIcon fontSize='small' /></IconButton>
                                            </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                    <div style={{ display: "flex", justifyContent: "start", alignItems: "start", flexDirection: "column", marginBottom: "20px" }}>
                        <div style={{ display: "flex", justifyContent: "space-between", width: "100%", marginBottom: 10 }}>
                            <div>
                                <Typography style={{ color: "#212121" }}>Car</Typography>
                            </div>
                            <Button variant='outlined' color='primary' size='small' onClick={() => addParkingSlots(4)} startIcon={<AddIcon />} >Add</Button>
                        </div>
                        {
                            carSlots && carSlots[0] && carSlots.map((val, index) => {
                                return (
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', marginBottom: 10, marginTop: 10, gap: 20 }}>

                                        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 250px))", gap: 20, width: "100%" }}>
                                            <MuiTextField
                                                label="Slot Name"
                                                size="small"
                                                value={val.slot_name}
                                                onChange={(e) => { onChangeCarHandler(e, index) }}
                                                variant='outlined'
                                            />
                                        </div>
                                        {
                                            slotAreas[0] && 
                                            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 250px))", gap: 20, width: "100%" }}>
                                                <MuiTextField
                                            size="small"
                                            variant="outlined"
                                            label="Slot Area"
                                            select
                                            value={val.slot_area_id}
                                            onChange={(e) => { onChangeCarSlotArea(e, index) }}
                                        >
                                            <MenuItem value=""></MenuItem>
                                            {slotAreas.map((area, index) => (
                                                <MenuItem key={index} value={area.id}>
                                                    {area.name}
                                                </MenuItem>
                                            ))}
                                        </MuiTextField>
                                            </div>
                                        }
                                        <div>
                                            <IconButton style={{ width: 25, height: 25 }} onClick={() => removeParkingSlots(val, index)}> <CloseIcon fontSize='small' /></IconButton>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </AccordionDetails>
        </Accordion>
    </>
}

// function CreateUserButton(props) {
//     const { record, source } = props;
//     const isSmallDevice = useMediaQuery(theme => theme.breakpoints.down("xs"));

//     const [dialogVisible, setDialogVisible] = React.useState(false);

//     const openDialog = () => {
//         setDialogVisible(true);
//     };

//     const closeDialog = () => {
//         setDialogVisible(false);
//     };

//     const handleUpdate = (event) => {
//         event.preventDefault();
//         closeDialog();
//         const { dispatchCrudUpdate, resource, basePath } = props;
//         const data = {
//             ...record,
//             create_user: 1
//         };
//         dispatchCrudUpdate(resource, record.id, data, record, basePath, "/rfidOrganization");
//     };

//     return (
//         <div style={{ display: isSmallDevice ? "flex" : "block", alignItems: "center", flex: 1 }}>
//             {record[source] ?
//                 record[source]
//                 :
//                 <RaButton disabled={props.disabled} label="Create User" color="secondary" onClick={openDialog}><PersonAddIcon /></RaButton>
//             }

//             <Dialog fullWidth open={dialogVisible} onClose={closeDialog}>
//                 <DialogContent>Are you sure you want to create a user for this company?</DialogContent>
//                 <DialogActions>
//                     <Button color="default" onClick={closeDialog}>No</Button>
//                     <Button color="secondary" onClick={handleUpdate}>Yes</Button>
//                 </DialogActions>
//             </Dialog>
//         </div>
//     );
// }

// CreateUserButton.defaultProps = {
//     redirect: 'list',
//     undoable: false
// };

// const CustomCreateUserButton = compose(
//     connect(
//         null,
//         { dispatchCrudUpdate: crudUpdate }
//     ),
//     translate
// )(CreateUserButton);